import { ref, computed, watchEffect } from 'vue';
import Request from '@/services/request';
import {
  REJECTED_REASONS,
} from '@/utils/enum/endpoints'

const Req = new Request();

const DEFAULT_PAGE_COUNT = -1;
const DEFAULT_RESULT_COUNT = -1;

export default function useService(pagination, taskId) {
  const data = ref(null);
  const totalResultCount = ref(DEFAULT_RESULT_COUNT);
  const error = ref(null);
  const isLoading = ref(false);
  const request = ref(null);
  const pageCount = ref(DEFAULT_PAGE_COUNT);


  const requestParams = computed(() => {
    const { pageSize, pageIndex } = pagination.value;
    const currentPage = pageIndex;

    return {
      page: currentPage,
      size: pageSize,
      type: 'ALL',
    };
  });

  watchEffect(() => {
    isLoading.value = true;
    const endpoint = REJECTED_REASONS;
    const resolvedEndpoint = endpoint.replace('{taskId}', taskId);

    request.value = Req.get(resolvedEndpoint, requestParams.value)
      .then(async (response) => {
        if (response.status === 200) {
          data.value = response.data.detailDTOList || [];
          totalResultCount.value = response.data.pageable?.totalItemCount || DEFAULT_RESULT_COUNT;
          pageCount.value = response.data.pageable?.totalPageCount || DEFAULT_PAGE_COUNT;
          error.value = null;
        } else {
          throw new Error('Network response was not OK');
        }
      })
      .catch((err) => {
        error.value = err || null;
        data.value = null;
        totalResultCount.value = DEFAULT_RESULT_COUNT;
        pageCount.value = DEFAULT_PAGE_COUNT;
      })
      .finally(() => {
        isLoading.value = false;
      });
  });

  return {
    data,
    totalResultCount,
    pageCount,
    error,
    isLoading,
  };

}